// extracted by mini-css-extract-plugin
export default {"buttonContainer":"FamilyInviteChildSelectionV2__buttonContainer___OAMAy"};